// extracted by mini-css-extract-plugin
export default {"table":"GmH2uQcM","no-header-top-border":"CE8Y7Rip","noHeaderTopBorder":"CE8Y7Rip"};